const detailsElements = document.getElementsByClassName('mega-menu');
const menuItems = document.getElementsByClassName('mega-menu');

for (let i = 0; i < menuItems.length; i++) {
  menuItems[i].addEventListener('mouseenter', function() {
    detailsElements[i].setAttribute('open', '');
  });

  menuItems[i].addEventListener('mouseleave', function() {
    detailsElements[i].removeAttribute('open');  // Remove the 'open' attribute
  });
}


$(document).ready(function() {
  var button = $('<button class="de-select-subscription">Uncheck</button>');
  $('.shopify_subscriptions_purchase_option_wrapper label').after(button);
  $('.de-select-subscription').on('click', function() {
    $('.shopify_subscriptions_purchase_option_wrapper label input').trigger('click');
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.product__accordion details');

  accordions.forEach(function(accordion) {
    accordion.addEventListener('toggle', function() {
      if (this.open) {
        // Close all other accordions
        accordions.forEach(function(otherAccordion) {
          if (otherAccordion !== accordion) {
            otherAccordion.removeAttribute('open');
          }
        });
      }
    });
  });
});


// if($('#additional_information_openModal').length > 0) {
//    document.getElementById('additional_information_openModal').onclick = function() {
//       document.getElementById('additional_information_Modal').style.display = "block";
//       document.body.style.overflow = 'hidden';
//       modal.classList.add('show');
//   } 
// }

for (let i = 1; i <= 4; i++) {
    const buttonId = `additional_information_openModal_${i}`;
    const modalId = `additional_information_Modal_${i}`;

    const button = document.getElementById(buttonId);
    const modal = document.getElementById(modalId);

    if (button) {
        button.onclick = function() {
            modal.style.display = "block";
            document.body.style.overflow = 'hidden';
            modal.classList.add('show');
        };
    }

    const closeButton = modal ? modal.querySelector('.additional-information-close') : null;
    if (closeButton) {
        closeButton.onclick = function() {
            modal.style.display = "none";
            document.body.style.overflow = 'auto';
            modal.classList.remove('show');
        };
    }
}

// Close any modal when clicking outside of it
window.onclick = function(event) {
    for (let i = 1; i <= 4; i++) {
        const modalId = `additional_information_Modal_${i}`;
        const modal = document.getElementById(modalId);

        if (modal && event.target === modal) {
            modal.style.display = "none";
            document.body.style.overflow = 'auto';
            modal.classList.remove('show');
        }
    }
};




setTimeout(function(){
  if ($("#simple-bundles-io-options").length > 0) {
      $(".main_product_page .product-form__buttons .product-form__submit").css('margin-top', '0px');
      $(".main_product_page .product-form__buttons .product-form__submit").css('float', 'none');
      $(".main_product_page .product-form__buttons .product-form__submit").css('width', '100%');
  }
}, 500);

if ($(".biscuits-bundle-step__products").length > 0) {
    $(".main_product_page .product-form__buttons .product-form__submit").css('margin-top', '0px');
    $(".main_product_page .product-form__buttons .product-form__submit").css('float', 'none');
        $(".main_product_page .product-form__buttons .product-form__submit").attr('style', function(i, style) {
        return (style || '') + ' width: 100% !important;';
    });
}
  


const close_menu = document.getElementById('close_menu');
const menu_drawer = document.getElementById('Details-menu-drawer-container');

// Add click event listener to the button
close_menu.addEventListener('click', function() {
    // Remove the title attribute from the div
    menu_drawer.removeAttribute('open');
    const expan_attr =  menu_drawer.querySelector('.header__icon--menu');
    expan_attr.setAttribute('aria-expanded', 'false')
});

document.addEventListener("DOMContentLoaded", function () {
 // Handle the button click event for deferred video play
 const videoButtons = document.querySelectorAll('.deferred-media__poster');

 videoButtons.forEach(button => {
   button.addEventListener('click', () => {
     // Get the video URL from the data-source attribute
     const videoUrl = button.dataset.source;

     if (videoUrl) {
       // Handle the video: create a video element and autoplay
       const mainBlock = document.querySelector('.large_image .product__media');
       
       if (!mainBlock) {
         console.error('Main block container not found!');
         return; // Exit if the main block is not found
       }

       // Create and configure the video element
       const newVideo = document.createElement('video');
       newVideo.src = videoUrl;
       newVideo.autoplay = true;
       newVideo.controls = true;  // Optional: Add controls
       newVideo.classList.add('product__media-video');
       
       // Clear the existing content in the mainBlock and append the new video
       mainBlock.innerHTML = '';  // Clear any previous media
       mainBlock.appendChild(newVideo);
     } else {
       console.error('Video source not found in data-source!');
     }
   });
 });

 // Existing code for handling thumbnail click events, image switching, etc.
 const smallImages = document.querySelectorAll('.small_product_img');

 smallImages.forEach(smallImg => {
   smallImg.addEventListener('click', () => {
     // Your existing logic for handling image changes, thumbnail activation, etc.
     const mainBlock = document.querySelector('.large_image .product__media');
     
     if (!mainBlock) {
       console.error('Main block container not found!');
       return; // Exit if the main block is not found
     }

     const mediaType = smallImg.dataset.mediaType;

     if (mediaType === 'video' || mediaType === 'external_video') {
       // Handle video: create a video element and autoplay
       const videoElement = smallImg.querySelector('video');
       const videoSource = videoElement ? videoElement.querySelector('source') : null;
       
       if (videoSource) {
         const videoUrl = videoSource.src;  // Get the video URL from the <source> tag
         const newVideo = document.createElement('video');
         newVideo.src = videoUrl;
         newVideo.autoplay = true;
         newVideo.controls = true;  // Optional: Add controls
         newVideo.classList.add('product__media-video');
         
         mainBlock.innerHTML = '';  // Clear any previous media
         mainBlock.appendChild(newVideo);
       } else {
         console.error('Video source not found!');
       }
     } else {
       // Handle image: replace it with a large image
       const imgElement = smallImg.querySelector('img');
       const newImg = document.createElement('img');
       newImg.src = imgElement.src.replace('thumbnail', 'large');
       newImg.alt = imgElement.alt || '';
       newImg.srcset = imgElement.srcset || '';
       newImg.width = imgElement.width;
       newImg.height = imgElement.height;
       newImg.loading = imgElement.loading || 'lazy';
       newImg.className = imgElement.className;

       mainBlock.innerHTML = '';  // Clear any previous media
       mainBlock.appendChild(newImg);
     }
     
     // Remove 'active' class from all thumbnails
     document.querySelectorAll('li').forEach(li => li.classList.remove('active'));

     // Add 'active' class to the clicked thumbnail
     const smallImgLi = smallImg.closest('li');
     if (smallImgLi) {
       smallImgLi.classList.add('active');
     }

     // Add 'active' class to the corresponding large image or video
     const bigImgId = mainBlock.id;
     const bigImg = document.getElementById(bigImgId);
     if (bigImg) {
       const bigImgLi = bigImg.closest('li');
       if (bigImgLi) {
         bigImgLi.classList.add('active');
       }
     }
   });
 });
});

// const smallImages = document.querySelectorAll('.small_product_img');

// smallImages.forEach(smallImg => {
//     smallImg.addEventListener('click', () => {
//         // Get the ID of the clicked small image
//         const click_image = smallImg.querySelector('img');
//         const main_block = document.querySelector('.large_image .product__media');
      
//         const newImg = document.createElement('img');
//         newImg.src = click_image.src.replace('thumbnail', 'large');
//         newImg.alt = click_image.alt || ''; // Use the alt from the thumbnail if available
//         newImg.srcset = click_image.srcset; // Copy the srcset
//         newImg.width = click_image.width; // Copy the width
//         newImg.height = click_image.height; // Copy the height
//         newImg.loading = click_image.loading; // Copy the loading attribute
//         newImg.className = click_image.className;
//         main_block.innerHTML = '';
//         main_block.appendChild(newImg);
      
//         // Remove 'active' class from all li elements
//         const allListItems = document.querySelectorAll('li');
//         allListItems.forEach(li => li.classList.remove('active'));

//         const smallImgLi = smallImg.closest('li');
//         if (smallImgLi) {
//             smallImgLi.classList.add('active');
//         }

//         const bigImgId = main_block.id; 
//         const bigImg = document.getElementById(bigImgId);
//         if (bigImg) {
//             const bigImgLi = bigImg.closest('li');
//             if (bigImgLi) {
//                 bigImgLi.classList.add('active');
//             }
//         }
//     });
// });

const intervalId = setInterval(() => {
    const element = document.getElementById('quantity-discount-app');
    if (element) {
      console.log("found");
      setTimeout(function(){
        const offers_options = document.querySelectorAll('input[name="choose_list"]');
        offers_options.forEach((radio) => {
          radio.addEventListener('change', () => {
              const parentElement = radio.closest('.choose_list_line');
        
              // Get the count from the 'choose_list_count' span within that parent
              const countElement = parentElement.querySelector('.choose_list_count');
              const countValue = countElement ? countElement.innerText : '';
              if(countValue) {
                const quantitySelect = document.querySelector('input[name="quantity"]');
                quantitySelect.value = countValue;
              } else {
                quantitySelect.value = 1;
              }
          });
        });
      }, 2000);
      clearInterval(intervalId);
    } else {
      // console.log("not found");
    }
}, 1000);

function addStylesToIframe() {
  console.log('start');
            const iframe = document.querySelector('.component-frame');

            if (iframe && iframe.contentDocument) {
                const doc = iframe.contentDocument;

                // Create a new style element
                const style = doc.createElement('style');
                style.textContent = `
                    body {
                        background-color: lightblue; /* Change background color */
                    }
                    h1 {
                        color: darkblue; /* Change h1 text color */
                    }
                `;
                
                // Append the style element to the head of the iframe's document
                doc.head.appendChild(style);
              console.log("Iframe ready");
            } else {
                console.log("Iframe not ready or cross-origin.");
            }
        }

 function addstyle() {
            // Use a timeout to ensure styles are added after the content is fully loaded
            setTimeout(addStylesToIframe, 200); // 100 ms timeout
        };
addstyle();
